import type { GenieDetailsTabProps } from "@/types/voice/genie-details";
import { DEFAULT_BRANDING } from "@/types/ui/branding";
import { MagicalIconButton } from "./MagicalIconButton";
import { useLiveAgentOptional } from "../LiveAgentContext";
import { GenieIcon } from "@/components/ui/genie-icons/GenieIcon";

/**
 * The single, quiet affordance on the right edge of the live-agent page —"
 * present before, during, and after the conversation. One tap poofs the whole
 * screen over to the Details view (about, links, resources, summary).
 *
 * Styled to match the bottom action row exactly: the same circular
 * MagicalIconButton + small grey label beneath, painted with the branded book
 * icon so it reads as one of the same family of controls.
 */
export const GenieDetailsTab = ({
  onClick,
  brandColor: brandColorProp,
  secondaryColor: secondaryColorProp,
  label = "Links & resources",
}: GenieDetailsTabProps) => {
  const liveAgent = useLiveAgentOptional();
  const brandColor = brandColorProp ?? liveAgent?.brandColor ?? DEFAULT_BRANDING.primaryColor;
  const secondaryColor = secondaryColorProp ?? liveAgent?.secondaryColor;
  return (
    <MagicalIconButton
      onClick={onClick}
      brandColor={brandColor}
      secondaryColor={secondaryColor}
      size={44}
      width={84}
      labelMaxWidthClass="max-w-[7.5rem]"
      ariaLabel={`Open ${label.toLowerCase()} — about, links, resources & summary`}
      label={label}
      hoverHint="About, links & resources"
      hintPlacement="top"
      hintAlign="right"
    >
      <GenieIcon name="book-open" size={22} color={brandColor} />
    </MagicalIconButton>
  );
};

export default GenieDetailsTab;
